import { render, staticRenderFns } from "./TopTabbar.vue?vue&type=template&id=594ccafa&scoped=true&"
import script from "./TopTabbar.vue?vue&type=script&lang=js&"
export * from "./TopTabbar.vue?vue&type=script&lang=js&"
import style0 from "./TopTabbar.vue?vue&type=style&index=0&id=594ccafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ccafa",
  null
  
)

export default component.exports